import RootLayout from "../RootLayout";
import IndexLayout from "../Layouts/IndexLayout";
import PagesLayaut from '../Layouts/PagesLayaut';
import MainLayout from "../Layouts/MainLayout";

import { createBrowserRouter } from "react-router-dom";


import Profesionales from '../Pages/Profesionales/Profesionales';
import Pacientes from '../Pages/Pacientes/Pacientes';
import Productos from '../Pages/Productos/Productos';
import Usuarios from '../Pages/Usuarios/Usuarios';
import Banners from "./Banners/Banners";
import Main from "./Main/Main";
import Configuracion from "./Configuracion/Configuracion";
import Contacto from "./Contacto/Contacto";
import Categorias from "./Categorias/Categorias";
import Codigos from "./Codigos/Codigos";
import PageDetail from '../Pages/PageDetail/PageDetail';
import PageProductos from "./PageProductos/PageProductos";
import Pedidos from "./Pedidos/Pedidos";
import Reservas from "./Reservas/Reservas";
import Testimonios from "./Testimonios/Testimonios";
import PWA from "./PWA/PWA";
import Sucursales from "./Sucursales/Sucursales";
import Horarios from "./Horarios/Horarios";
import Inventarios from "./Inventarios/Inventarios";
import Gastos from "./Gastos/Gastos";
import Evaluaciones from "./Evaluaciones/Evaluaciones";
import PaymentMethods from "./PaymentMethods/PaymentMethods";
import Reportes from "./Reportes/Reportes";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />, // <-- RootLayout contiene ScrollToTop y <Outlet />
    children: [
      // Public / index
      { index: true, element: <IndexLayout /> },

      // Pages layout group
      {
        element: <PagesLayaut />,
        children: [
          { path: "producto/:idProducto/:producto", element: <PageDetail /> },
          { path: "productos", element: <PageProductos /> },
        ],
      },

      // Main/dashboard group
      {
        element: <MainLayout />,
        children: [
          { path: "dashboard", element: <Main /> },
          { path: "dashboard/profesionales", element: <Profesionales /> },
          { path: "dashboard/pacientes", element: <Pacientes /> },
          { path: "dashboard/productos", element: <Productos /> },
          { path: "dashboard/reservas", element: <Reservas /> },
          { path: "dashboard/usuarios", element: <Usuarios /> },
          { path: "dashboard/banners", element: <Banners /> },
          { path: "dashboard/configuracion", element: <Configuracion /> },
          { path: "dashboard/contacto", element: <Contacto /> },
          { path: "dashboard/categorias", element: <Categorias /> },
          { path: "dashboard/codigos", element: <Codigos /> },
          { path: "dashboard/pedidos", element: <Pedidos /> },
          { path: "dashboard/testimonios", element: <Testimonios /> },
          { path: "dashboard/pwa", element: <PWA /> },
          { path: "dashboard/sucursales", element: <Sucursales /> },
          { path: "dashboard/horarios", element: <Horarios /> },
          { path: "dashboard/inventarios", element: <Inventarios /> },
          { path: "dashboard/gastos", element: <Gastos /> },
          { path: "dashboard/evaluaciones", element: <Evaluaciones /> },
          { path: "dashboard/medios-pago", element: <PaymentMethods /> },
          { path: "dashboard/reportes", element: <Reportes /> },
        ],
      }
    ]
  }
]);
